import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Login } from '../pages/Login';
import { Layout } from '../components/Layout';
import { Dashboard } from '../pages/Dashboard';
import { AmbienteList } from '../pages/ambiente/AmbienteList';
import { AmbienteForm } from '../pages/ambiente/AmbienteForm';
import { VMList } from '../pages/vm/VMList';
import { VMForm } from '../pages/vm/VMForm';
import { VMBackupList } from '../pages/vm/VMBackupList';
import { UsuarioList } from '../pages/usuario/UsuarioList';
import { UsuarioForm } from '../pages/usuario/UsuarioForm';
import { VolumeList } from '../pages/volume/VolumeList';
import { VolumeForm } from '../pages/volume/VolumeForm';
import { VolumeBackupList } from '../pages/volume/VolumeBackupList';
import { ContainerRegistry } from '../pages/registry/ContainerRegistry';
import { BucketList } from '../pages/buckets/BucketList';

interface PrivateRouteProps {
  children: React.ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="ambientes">
          <Route index element={<AmbienteList />} />
          <Route path="new" element={<AmbienteForm />} />
          <Route path=":id" element={<AmbienteForm />} />
        </Route>
        <Route path="vms">
          <Route index element={<VMList />} />
          <Route path="new" element={<VMForm />} />
          <Route path=":id" element={<VMForm />} />
        </Route>
        <Route path="vms-backup">
          <Route index element={<VMBackupList />} />
        </Route>
        <Route path="volumes">
          <Route index element={<VolumeList />} />
          <Route path="new" element={<VolumeForm />} />
          <Route path=":id" element={<VolumeForm />} />
        </Route>
        <Route path="volumes-backup">
          <Route index element={<VolumeBackupList />} />
        </Route>
        <Route path="usuarios">
          <Route index element={<UsuarioList />} />
          <Route path="new" element={<UsuarioForm />} />
          <Route path=":id" element={<UsuarioForm />} />
        </Route>
        <Route path="container-registry" element={<ContainerRegistry />} />
        <Route path="buckets" element={<BucketList />} />
      </Route>
    </Routes>
  );
} 